import { render } from "./Toggle.vue?vue&type=template&id=b9e801bc"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"
script.render = render

export default script